export default __webpack_public_path__ + "static/media/correspondent13.c246e669.png";